import { render, staticRenderFns } from "./PaymentThankYouPageMobile.vue?vue&type=template&id=405e7712&"
import script from "./PaymentThankYouPageMobile.vue?vue&type=script&lang=js&"
export * from "./PaymentThankYouPageMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports